define('helpers/MaintenanceHelper',['jquery', 'env'], function ($, Config) {
  var MaintenanceHelper = {};

  MaintenanceHelper.init = function (callback) {
    var maintenanceURL = Config.maintenanceUrl;

    // Get script from maintenanceURL and execute callback
    $.getScript(maintenanceURL).done(function () {
      window.maintenance = maintenance;
      if(callback) {
        callback();
      }
    });
  };

  MaintenanceHelper.isEnabled = function () {
    if (!window.maintenance) {
      return false;
    }

    return window.maintenance.enabled;
  };

  MaintenanceHelper.getCookieName = function () {
    if (!window.maintenance) {
      return '';
    }

    return window.maintenance.cookieName;
  };

  MaintenanceHelper.getCookieHash = function () {
    if (!window.maintenance) {
      return '';
    }

    return window.maintenance.cookieHash;
  };

  MaintenanceHelper.getRedirectUrl = function () {
    if (!window.maintenance) {
      return '';
    }

    return window.maintenance.redirectUrl;
  };

  return MaintenanceHelper;
});

